import React, { useState } from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    FormControl,
    Button,
    DialogTitle,
    TextField
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import axios from 'axios';
import { IoIosCloseCircle } from "react-icons/io";

const CreateChatOneToOne = ({ open, onClose, users, onChatCreate, userId }) => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [chatName, setChatName] = useState('');
    const rolesInGeorgian = {
        'HeadOfAgency': "სააგენტოს უფროსი",
        'DeputyHeadOfAgency': "უფროსის მოადგილე",
        'HeadOfDepartment': "სამმართველოს უფროსი",
        'Expert': "სპეციალისტი"
    };

    const handleUserChange = (event, newValue) => {
        setSelectedUser(newValue);

        if (newValue) {
            const creator = users.find(user => user.id === userId);
            setChatName(`${newValue.firstName} ${newValue.lastName} -userId: ${newValue.id}-separator-${creator.firstName} ${creator.lastName} -userId: ${creator.id} `);
        } else {
            setChatName('');
        }
    };

    const handleCreateChatGroup = async () => {
        if (!selectedUser) return;

        const uniqueSelectedUsers = Array.from(new Set([selectedUser.id, userId]));

        const payload = {
            chatName: chatName,
            chatUsersIds: uniqueSelectedUsers,
            caseNumber: ""
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewChatGroup`, payload);
            if (response.data.resultId) {
                const messagePayload = {
                    chatGroupId: parseInt(response.data.resultId),
                    message: "27015*&*&",
                    creatorUserID: userId,
                    creatorUserFullName: `27015*&*&`,
                    seenThisMessageUserIds: uniqueSelectedUsers
                };
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewChatMessage`, messagePayload);
            }

            onClose();
            onChatCreate();
        } catch (error) {
            console.error('Failed to create chat group:', error);
        }
    };

    return (
        <Dialog fullWidth maxWidth="lg" open={open} onClose={onClose}>
            <IoIosCloseCircle className="upload-single-close-icon-text-editor"
                              onClick={onClose}
            />
            <DialogContent>
                <DialogTitle>აირჩიეთ თანამშრომელი</DialogTitle>
                <FormControl fullWidth margin="dense">
                    <Autocomplete
                        options={users.filter(user => user.id !== userId)}
                        getOptionLabel={(option) => `${option.firstName} ${option.lastName} (${rolesInGeorgian[option.roleName]})`}
                        value={selectedUser}
                        noOptionsText="არაფერი მოიძებნა"
                        onChange={handleUserChange}
                        renderInput={(params) => (
                            <TextField {...params} label="აირჩიეთ თანამშრომელი" variant="outlined" />
                        )}
                    />
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button disabled={!selectedUser} onClick={handleCreateChatGroup} color="primary">
                    შექმნა
                </Button>
                <Button onClick={onClose} color="secondary">
                    გაუქმება
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateChatOneToOne;
